enum ModalMode {
  Edit,
  Add,
  Delete,
}

export default ModalMode
